<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="addSowingMethodForm"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm :infoData="model" ref="stepConfirm" />
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}:
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import FormWizard from 'src/components/Layouts/FormWizard.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';
import StepConfirm from './steps/StepConfirm.vue';

export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    StepConfirm,
  },
  data() {
    return {
      model: {
        id: null,
        name: null,
        code: null,
        type: null,
        sowing_type: null,
        seedType: null,
        distance: null,
        temperature: null,
        description: null,
        businesses_ids: [],
        businesses_names: [],
        seed_type_id: [],
        seedTypeName: [],
      },
    };
  },
  mixins: [MixinAlert, MixinLoading, MixinMenu, MixinPermissions],
  computed: {
    tabsContent() {
      return [
        {
          title: i18n.t('common_words.general_information'),
          reference: 'firstStep',
          component: FirstStep,
        },
        {
          title: i18n.t('common_words.specific_information'),
          reference: 'secondStep',
          component: SecondStep,
        },
      ];
    },
  },
  methods: {
    onStepValidated(dataModel) {
      this.model = { ...this.model, ...dataModel };
    },
    cleanAllSteps() {
      this.$refs.formWizard.$refs.firstStep[0].model = {
        id: null,
        name: null,
        code: null,
        type: null,
        sowing_type: null,
        seed_type_id: null,
        businesses_id: [],
        businesses_names: [],
      };
      this.$refs.formWizard.$refs.firstStep[0].$refs['select-businesses'].model = {
        associations_ids: [],
        businesses_ids: [],
        names: [],
      };
      this.$refs.formWizard.$refs.secondStep[0].model = {
        distance: null,
        temperature: null,
        description: null,
      };
      this.model = {
        id: null,
        name: null,
        code: null,
        type: null,
        sowing_type: null,
        seed_type_id: null,
        distance: null,
        temperature: null,
        description: null,
      };
    },
    addSowingMethodForm() {
      this.showHideLoading(true);
      this.model.route = 'seeding/sowingmethods';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/seeding/sowingmethods',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/seeding/sowingmethods',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('seeding/sowingmethods');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('seeding/sowingmethods');
  },
};
</script>
